import api from './api';
import type { SessionSchedulerHealth } from './schedulerHealth';

// Sprint 29 / Fase 29.B + 29.D — service do painel pra perf+diagnostic.
//
// Endpoints (admin):
//   GET /admin/diagnostics/{session_uuid}             → AggregatedDiagnostic
//   GET /admin/diagnostics/{session_uuid}/history?limit=N → SessionDiagnosticRaw[]

export interface PercentilesPerHotPath {
  hotpath_name: string;
  sample_count: number;
  p50_us: number;
  p95_us: number;
  p99_us: number;
  max_us: number;
}

export interface ProcessMetrics {
  rss_mb?: number;
  cpu_kernel_us?: number;
  cpu_user_us?: number;
  thread_count?: number;
  uptime_s?: number;
  // Sprint 29.D adicionou cpu_kernel_us + cpu_user_us; legacy field cpu_percent
  // pode aparecer em snapshots antigos (compat).
  cpu_percent?: number;
}

export interface AggregatedDiagnostic {
  session_uuid: string;
  captured_at: string;
  sdk_version: string;
  build_id: string;
  sanitized: boolean;
  hot_paths: PercentilesPerHotPath[];
  process_metrics: ProcessMetrics;
  /**
   * 2026-08-05 — saúde do escalonamento daquela sessão. `{}` quando o SDK
   * daquela sessão ainda não reporta. Diagnóstico operacional, nunca evidência
   * — ver lib/detectorHealth.ts.
   */
  scheduler_health?: SessionSchedulerHealth;
}

export interface SessionDiagnosticRaw {
  session_uuid: string;
  captured_at: string;
  created_at: string;
  sdk_version: string;
  build_id: string;
  sanitized: boolean;
  perf_snapshot: { samples: Record<string, Array<{ ts_ms: number; value_us: number }>> };
  process_metrics: ProcessMetrics;
  scheduler_health?: SessionSchedulerHealth;
}

export async function getLatestDiagnostic(sessionUuid: string): Promise<AggregatedDiagnostic> {
  const resp = await api.get<AggregatedDiagnostic>(`/admin/diagnostics/${sessionUuid}`);
  return resp.data;
}

export async function getDiagnosticHistory(
  sessionUuid: string,
  limit = 50,
): Promise<{ data: SessionDiagnosticRaw[]; count: number }> {
  const resp = await api.get<{ data: SessionDiagnosticRaw[]; count: number }>(
    `/admin/diagnostics/${sessionUuid}/history`,
    { params: { limit } },
  );
  return resp.data;
}
